

import React,{useRef } from 'react'
import '../../Styles/Teams.scss';
import coFounder from '../../Assests/Team/coFounder1.png';
import coFounder1 from '../../Assests/Team/coFounder2.png';
import founder from '../../Assests/Team/founder.png';
import OurtrustedPartner from './OurtrustedPartner';

function Team() {

  const teamSectionRef = useRef(null);

  const scrollToSection = () => {
    if (teamSectionRef.current) {
      teamSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='mt-5 pt-4'>
      <div className='py-5 team-discover-story w-100'>
        <div className='text-center fw-bold team-discover-story-text ' style={{color:"#2D143D"}}>
          <div>Discover the Story</div>
          <div>Behind Our Team</div>
        </div>
        <div className='text-center team-discover-sub '>
          <div>
            From vision to action, our team is dedicated to reshaping the future
          </div>
          <div>of health. Learn more about the people making it happen.</div>

          {/* Button container */}
          <div
            className='d-flex justify-content-center align-items-center mt-3'
          // style={{ width: "100%" }}
          >
            <div
              className=' d-flex justify-content-center  align-items-center  primary-btn ms-1 py-2 px-2 contact-us fw-bold read-btn'
              // style={{ width: "12%" }}
              onClick={scrollToSection}
            >
              <div >Read</div>
              <span className="material-symbols-outlined ms-1  arrow-downRead">arrow_downward</span>
            </div>
          </div>
        </div>
      </div>




      <div className='team-section' ref={teamSectionRef}>
        <div className='team-title fw-bold overall-text-color'>
          The Minds Behind Our Mission
        </div>

        <div className='team-row '>
          <div className='team-col'>
            <img src={founder} alt="founder" className='team-image' />
            <div className='founders-name mt-2'>
              Dr. Vishnu Vardhan
            </div>
            <div className='founders-sub'>
              Founder | VIZZHY
            </div>
          </div>

          <div className='team-col'>
            <img src={coFounder} alt="coFounder" className='team-image' />
            <div className='founders-name mt-2'>
              Mrs. Harsha Vardhini
            </div>
            <div className='founders-sub'>
              Co-Founder | VIZZHY
            </div>
          </div>

          <div className='team-col'>
            <img src={coFounder1} alt="coFounder1" className='team-image' />
            <div className='founders-name mt-2'>
              Mr. Kalyan
            </div>
            <div className='founders-sub'>
              Co-Founder | VIZZHY
            </div>
          </div>
        </div>
      </div>

      <OurtrustedPartner />
    </div>
  )
}
export default Team




// import React, { useState } from 'react';
// import JoinOurTeam from '../../Utils/JoinOurTeam';
// import ReusableModal from '../../Utils/ReusableModel';

// function Team() {
//   const [showModal, setShowModal] = useState(false);

//   const openModal = () => setShowModal(true);
//   const closeModal = () => setShowModal(false);

//   return (
//     <div>
//       <button onClick={openModal}>Join Our Team</button>

//       <ReusableModal
//         data="modal-xl"
//         showModal={showModal}
//         closeModal={closeModal}
//         content={<JoinOurTeam  closeModal={closeModal}/>}
//       />
//     </div>
//   );
// }

// export default Team;
